module.exports = __webpack_public_path__ + "img/mouth5.641f0649.svg";